export default __webpack_public_path__ + "static/media/sexAngel.3c07bf53.png";